import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        formControl: {
            '&&': {
                padding: theme.spacing(2),
                boxSizing: 'border-box',
                alignItems: 'center',
            },
        },
    }
})

export default useStyles
